(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZUGAirFreshenerStaleCartGuard = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var state = { staleKeys: [], checking: false, legacyIdsPromise: null };
  var scriptElement = typeof document !== 'undefined' ? document.currentScript : null;
  var manifestUrl = scriptElement && scriptElement.getAttribute('data-zug-af-legacy-manifest-url');

  function properties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isLegacyBase(item) {
    var props = properties(item);
    return props._is_air_freshener === 'true' &&
      props._pricing_engine === 'true' &&
      props._line_type === 'base' &&
      Boolean(String(props.calc_line_uid || '').trim()) &&
      !String(props._calc_line_uid || '').trim();
  }

  function legacyGroups(items, legacyVariantIds) {
    var list = Array.isArray(items) ? items : [];
    var groups = list.filter(isLegacyBase).map(function (base) {
      var uid = String(properties(base).calc_line_uid).trim();
      var members = list.filter(function (item) {
        var props = properties(item);
        return String(props.calc_line_uid || '').trim() === uid &&
          (item === base || props._line_type === 'adjustment');
      });
      return {
        uid: uid,
        keys: members.map(function (item) { return String(item.key || '').trim(); }).filter(Boolean)
      };
    });
    var ids = legacyVariantIds instanceof Set ? legacyVariantIds : new Set(legacyVariantIds || []);
    list.forEach(function (item) {
      var variantId = Number(item && (item.variant_id || item.id));
      var key = String(item && item.key || '').trim();
      if (!ids.has(variantId) || !key) return;
      groups.push({ uid: 'raw-variant-' + variantId, keys: [key] });
    });
    return groups;
  }

  function loadLegacyIds() {
    if (state.legacyIdsPromise) return state.legacyIdsPromise;
    if (!manifestUrl || typeof fetch === 'undefined') return Promise.resolve(new Set());
    state.legacyIdsPromise = fetch(manifestUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Air Freshener legacy-variant manifest failed to load.');
        return response.json();
      })
      .then(function (manifest) {
        var ids = (manifest.products || []).reduce(function (all, product) {
          return all.concat(product.variantIds || []);
        }, []).map(Number);
        if (ids.length !== manifest.expectedVariantCount || new Set(ids).size !== manifest.expectedVariantCount) {
          throw new Error('Air Freshener legacy-variant manifest is incomplete.');
        }
        return new Set(ids);
      });
    return state.legacyIdsPromise;
  }

  function setCheckoutBlocked(blocked) {
    if (typeof document === 'undefined') return;
    var selectors = '[name="checkout"], [href="/checkout"], form[action="/checkout"] button, form[action="/checkout"] input[type="submit"]';
    document.querySelectorAll(selectors).forEach(function (element) {
      if (blocked) {
        element.setAttribute('data-zug-af-stale-blocked', 'true');
        element.setAttribute('aria-disabled', 'true');
        if ('disabled' in element) element.disabled = true;
      } else if (element.getAttribute('data-zug-af-stale-blocked') === 'true') {
        element.removeAttribute('data-zug-af-stale-blocked');
        element.removeAttribute('aria-disabled');
        if ('disabled' in element) element.disabled = false;
      }
    });
  }

  function renderBanner(groups) {
    if (typeof document === 'undefined') return;
    var banner = document.getElementById('zug-af-stale-cart-guard');
    if (!groups.length) {
      if (banner) banner.remove();
      return;
    }
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'zug-af-stale-cart-guard';
      banner.setAttribute('role', 'alert');
      banner.style.cssText = 'position:fixed;z-index:2147483646;left:16px;right:16px;top:16px;padding:16px;border:2px solid #b42318;border-radius:8px;background:#fff1f0;color:#5f140d;box-shadow:0 8px 30px rgba(0,0,0,.2);font:600 14px/1.4 system-ui,sans-serif';
      banner.innerHTML = '<span>An older Air Freshener configuration in this cart must be removed and rebuilt before checkout.</span> <button type="button" data-zug-af-remove-stale style="margin-left:12px;padding:8px 12px;border:0;border-radius:5px;background:#b42318;color:white;font-weight:700;cursor:pointer">Remove old Air Freshener item</button>';
      document.body.appendChild(banner);
      banner.querySelector('[data-zug-af-remove-stale]').addEventListener('click', removeStaleGroups);
    }
  }

  function apply(groups) {
    state.staleKeys = Array.from(new Set(groups.reduce(function (keys, group) { return keys.concat(group.keys); }, [])));
    setCheckoutBlocked(state.staleKeys.length > 0);
    renderBanner(groups);
  }

  function check() {
    if (typeof fetch === 'undefined' || state.checking) return Promise.resolve([]);
    state.checking = true;
    return Promise.all([
      loadLegacyIds().catch(function (error) {
        console.error('[ZUG-AF] legacy-variant manifest unavailable', error);
        return new Set();
      }),
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw new Error('Air Freshener stale-cart check failed.');
          return response.json();
        })
    ])
      .then(function (results) {
        var groups = legacyGroups(results[1].items, results[0]);
        apply(groups);
        return groups;
      })
      .catch(function (error) {
        console.error('[ZUG-AF] stale-cart guard failed closed', error);
        setCheckoutBlocked(state.staleKeys.length > 0);
        return [];
      })
      .finally(function () { state.checking = false; });
  }

  function removeStaleGroups() {
    if (!state.staleKeys.length) return Promise.resolve();
    var updates = {};
    state.staleKeys.forEach(function (key) { updates[key] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Old Air Freshener removal failed.');
      return response.json();
    }).then(function () {
      apply([]);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function (error) {
      alert('Unable to remove the older Air Freshener item. Please refresh and try again.');
      throw error;
    });
  }

  function blockCheckoutEvent(event) {
    if (!state.staleKeys.length) return;
    var target = event.target && event.target.closest
      ? event.target.closest('[name="checkout"], [href="/checkout"], form[action="/checkout"]')
      : null;
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    renderBanner([{ keys: state.staleKeys }]);
  }

  function init() {
    if (typeof document === 'undefined') return;
    document.addEventListener('click', blockCheckoutEvent, true);
    document.addEventListener('submit', blockCheckoutEvent, true);
    document.addEventListener('cart:refresh', check);
    document.addEventListener('cart:change', check);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
    else check();
  }

  if (typeof window !== 'undefined') init();

  return {
    isLegacyBase: isLegacyBase,
    legacyGroups: legacyGroups,
    loadLegacyIds: loadLegacyIds,
    check: check,
    removeStaleGroups: removeStaleGroups
  };
});
